import React, { useEffect, useState } from "react";
import Container from "../../../components/Container";
import { BtnPadrao, BtnDeletar, BtnEdit, ModalPadrao, LabelPadrao, InputPadrao, CheckBoxPadrao, LoadingContainerPadrao, BtnIncluir } from "../../../components/Base";
import { Divider } from "antd";
import TabelaPadrao from "../../../components/TabelaPadrao";
import * as api from "./api";
import { useFetch, useSave } from "../../../components/Hooks/Conexao";
import Mensagens from "../../../components/Mensagens";
import { connect } from "react-redux";
import { logIn, fetch } from "../../../actions/index";
import { useParams } from "react-router-dom";

function Caracteristicas(props) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [detalhe, setDetalhe] = useState(null);
  const { name } = useParams();
  const [title, setTitle] = useState();

  useEffect(() => {
    if (name === "segmento") setTitle("Segmento");
    if (name === "fxFaturamento") setTitle("Faixa do Faturamento");
    if (name === "portepdv") setTitle("Porte Pdv");
    if (name === "modeloneg") setTitle("Modelo Negocio");
    if (name === "tipoemp") setTitle("Tipo Empresa");
    if (name === "perfil") setTitle("Perfil");
    if (name === "rgComer") setTitle("Região Comercial");
    if (name === "rgGeo") setTitle("Região Geografica");
    if (name === "rede") setTitle("Rede");
    if (name === "federacao") setTitle("Federação");
  }, [name]);

  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
    },
    {
      Header: " ",
      accessor: "id",
      tipo: "right",
      Cell: data => {
        const row = data.row.original.id;
        return (
          <div>
            <BtnEdit style={{ marginRight: 10 }} onClick={() => setDetalhe(row)} />
            <BtnDeletar
              onOk={() =>
                listarDados(
                  () => api.deletar(props.fetch, row),
                  () => {
                    const aux = [...dados];
                    aux.splice(
                      dados.findIndex(x => x.id === row),
                      1
                    );
                    setDados(aux);
                    Mensagens.showSucesso("Característica excluída com sucesso!");
                  }
                )
              }
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    listarDados(() => api.getAll(props.fetch, name));
  }, [name]);

  function onOk(v) {
    const aux = [...dados];

    const regInx = aux.findIndex(x => x.id === v.id);

    if (aux.findIndex(x => x.id === v.id) !== -1) {
      aux[regInx] = v;
    } else {
      aux.push(v);
    }
    setDados(aux);
    setDetalhe(null);
  }

  if (!title) {
    return null;
  }

  return (
    <>
      <Container loading={loading}>
        <div>
          <Divider orientation="left">{title}</Divider>
          <BtnIncluir type="primary" onClick={() => setDetalhe(-1)} ghost />
        </div>
        <TabelaPadrao columns={columns} data={dados} style={{ margin: "25px 0" }} />
      </Container>
      <ModalInserir tipo={name} title={title} fetch={props.fetch} onCancel={() => setDetalhe(null)} onOk={onOk} id={detalhe} />
    </>
  );
}
export default connect(null, { logIn, fetch })(Caracteristicas);

function ModalInserir({ id, tipo, onOk, onCancel, title, fetch, ...props }) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [save, saving] = useSave(
    () => api.post(fetch, { ...dados, tipo }),
    v => {
      if (v) onOk({ ...dados, id: v });
      else onOk(dados);
      Mensagens.showSucesso("Dados salvos com sucesso!");
    }
  );

  function onSave() {
    if (!dados.nome) {
      Mensagens.showErro("Dados não preenchidos!");
      return;
    }
    save();
  }

  useEffect(() => {
    if (id) listarDados(() => api.getDetalhe(fetch, id));
  }, [id]);

  return (
    <ModalPadrao
      visible={id}
      onCancel={onCancel}
      title={title}
      footer={
        <>
          <BtnPadrao type="primary" onClick={onSave} loading={saving}>
            Gravar
          </BtnPadrao>
          <BtnPadrao type="primary" onClick={onCancel} ghost>
            Sair
          </BtnPadrao>
        </>
      }
    >
      <LoadingContainerPadrao loading={loading}>
        <div>
          <LabelPadrao noMargin>Nome</LabelPadrao>
          <InputPadrao value={(dados || []).nome} onChange={v => setDados({ ...dados, nome: v.target.value })} autoFocus />
        </div>
      </LoadingContainerPadrao>

      {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
    </ModalPadrao>
  );
}
